<template>
  <div id="user-address">
    <div class="modal user-address-modal">
      <div class="modal-background" @click="closeModal"></div>
      <button class="modal-close is-large" @click="closeModal"></button>

      <div class="modal-card">
        <section class="modal-card-body has-text-left">
          <p class="header">
            {{ $t("profile.set-address") }}
            <i
              class="fa fa-info-circle fa-sm has-text-grey is-pulled-right"
              style="padding: 4px 0"
              @click="showInfo"
            />
          </p>
          <!-- <div class="notification" style="padding: 12px"> -->
          <div class="field" style="margin-bottom: 0">
            <p class="control has-icons-left">
              <input
                class="input is-medium"
                v-model="locationInput"
                ref="autocomplete"
                placeholder="Location"
                onfocus="value = ''"
                onpaste="return false;"
                ondrop="return false;"
                autocomplete="off"
                v-on:keyup="checkLength"
                type="text"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-globe-asia" />
              </span>
            </p>
          </div>

          <div v-if="error" style="margin-top: 10px">
            <i class="has-text-primary">{{ error }}</i>
          </div>

          <div v-if="fullAddress" class="field">
            <div
              class="notification is-white has-text-left"
              style="padding: 10px; margin-bottom: 0"
            >
              <p>
                <span style="color: grey; font-weight: 500">Address:</span>
                {{ fullAddress }}
              </p>
            </div>
            <p class="control">
              <button class="button is-success is-fullwidth" @click="submit">
                {{ $t("save") }}
              </button>
            </p>
          </div>
          <!-- </div> -->
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";

export default {
  name: "UserAddressModal",
  data() {
    return {
      error: "",
      locationInput: "",
      autocomplete: undefined,
      place: undefined, // google place result
      addressName: "",
      fullAddress: "",
      // addressType: ""
    };
  },
  computed: {},
  mounted() {
    var url = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(url, () => this.initGoogle());
  },
  methods: {
    closeModal() {
      //   this.componentKey += 1; // this should have reset everything...but doesn't
      //   this.isResult = false;
      this.locationInput = "";
      this.fullAddress = "";
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    showInfo() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-map-marker-alt has-text-grey'></i>&nbsp;Set Address
        </p>
        <p style='margin-bottom:12px'>
        If you set your home or work address they will show as suggestions when you place an order.
        </p>
         <p style='margin-bottom:12px'>
        This is optional. You will be able to enter any location at the time of each order.
        </p>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    checkLength(val) {
      this.console("checkLength", val, this.locationInput);
      if (this.locationInput && this.locationInput.length > 15) {
        this.error = `Please select an address from list (Thailand only)`;
      } else this.error = "";
    },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [], // uses all, options are ["address", "establishment", "geocode"]
          componentRestrictions: { country: "th" },
        }
      );
      this.geolocate();

      this.autocomplete.addListener("place_changed", () => {
        this.error = "";
        var place = this.autocomplete.getPlace();
        this.addressName = place.name;
        this.fullAddress = place.formatted_address;
        this.url = place.url;
        this.place = place;

        this.locationInput = place.name; //place.types.join(", ");
        this.console(`The user picked ${name}`, place);
      });
    },
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    submit() {
      const address = {
        name: this.addressName,
        address: this.fullAddress,
        lat: this.place.geometry.location.lat(),
        lon: this.place.geometry.location.lng(),
      };
      this.console("address", address);
      this.$emit("submitAddress", address);
      this.closeModal();
      // address_type: this.addressType,
      // address: this.fullAddress,
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  padding: 12px;
}
.header {
  font-size: 1.5em;
  margin-bottom: 6px;
}
</style>